//This function checks if a string starts with the filter value, if not it splits the string into an array of words, and checks if any of them start with the filter value.
//The function returns true if the string starts with the filter value or if any of the words in the string start with the filter value.
export function findMatch(string: string, filterValue: string): boolean {
  const query = filterValue.toLowerCase().trim();
  string = string.toLowerCase();

  if (string.startsWith(query)) {
    return true;
  }

  const keyArray = string.split(" ");
  for (let i = 0; i < keyArray.length; i++) {
    if (keyArray[i].startsWith(query)) {
      return true;
    }
  }
  return false;
}
